function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { CLEAR_ALL_CLICKED } from "constants/bigbrain-event-types";
import { StyledWhatsNewPageFilters } from "./filters.scss";
import Filter from "./filter/filter";
import { trackEvent } from "/services/bigbrain-service";
import SearchIcon from "/static/svg/search.svg";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
const WhatsNewPageFilters = ({ filtersSchema, filterValues, onChange, setFilterValues, handleTextSearchChange, textSearch, hideProductFilter })=>{
    const [openFilterId, setOpenFilterId] = useState(null);
    const clearFilters = ()=>{
        setOpenFilterId(null);
    };
    const handleToggleFilter = useCallback((id)=>{
        if (openFilterId === id) {
            clearFilters();
        } else {
            setOpenFilterId(id);
        }
    }, [
        openFilterId
    ]);
    const handleClearAllFilters = ()=>{
        const newFilterValues = {};
        filtersSchema.forEach(({ id })=>{
            newFilterValues[id] = [];
        });
        onChange(newFilterValues);
        setFilterValues(newFilterValues);
        clearFilters();
        handleTextSearchChange({
            target: {
                value: ""
            }
        });
        trackEvent(CLEAR_ALL_CLICKED);
    };
    const handleFiltersChange = (id, values)=>{
        const newFilterValues = _object_spread_props(_object_spread({}, filterValues), {
            [id]: values
        });
        onChange(newFilterValues);
    };
    return /*#__PURE__*/ _jsx(StyledWhatsNewPageFilters, {
        className: "filters-container",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "filters-content",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-filter-container",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "search-icon-wrapper",
                            children: /*#__PURE__*/ _jsx(SearchIcon, {})
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            placeholder: "Search",
                            value: textSearch,
                            onChange: handleTextSearchChange
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "filters-title",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: "Filters"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "clear-all",
                            onClick: handleClearAllFilters,
                            onKeyDown: generateOnKeyDownHandler(()=>{
                                handleClearAllFilters();
                            }),
                            tabIndex: 0,
                            role: "button",
                            children: "Clear all"
                        })
                    ]
                }),
                filtersSchema.map(({ id, title, data })=>/*#__PURE__*/ _jsx(Filter, {
                        id: id,
                        title: title,
                        data: data,
                        values: filterValues[id],
                        isOpen: openFilterId === id,
                        onToggle: ()=>handleToggleFilter(id),
                        onChange: (values)=>handleFiltersChange(id, values),
                        hideProductFilter: hideProductFilter && id === "product"
                    }, `${id}-${JSON.stringify(filterValues)}`))
            ]
        })
    });
};
export default WhatsNewPageFilters;
